import React from 'react';
import { Card, CardContent } from './ui/card';
import { TrendingUp, Shield, BarChart3, Database, Code, Users } from 'lucide-react';

export const Services = () => {
  const services = [
    {
      icon: TrendingUp,
      title: 'Stratégie & Consulting',
      description: 'Accompagnement dans votre transformation digitale avec des outils performants et une roadmap claire.',
      color: 'from-blue-500 to-cyan-500',
    },
    {
      icon: Users,
      title: 'Expérience Utilisateur',
      description: 'Interfaces intuitives, parcours simplifiés et onboarding rapide pour acheteurs et vendeurs.',
      color: 'from-purple-500 to-pink-500',
    },
    {
      icon: Shield,
      title: 'Gestion des Risques',
      description: 'Communication claire, anticipation des risques et respect des délais qualité coût.',
      color: 'from-green-500 to-emerald-500',
    },
    {
      icon: BarChart3,
      title: 'Pilotage Performance',
      description: 'Définition et suivi des KPIs : taux de conversion, panier moyen, rétention, satisfaction.',
      color: 'from-orange-500 to-red-500',
    },
    {
      icon: Database,
      title: 'Data Intelligence',
      description: 'Collecte, intégration et visualisation des données avec dashboards dynamiques 360°.',
      color: 'from-indigo-500 to-blue-500',
    },
    {
      icon: Code,
      title: 'Développement Apps',
      description: 'Solutions web et mobile intégrées : front-end, middle-end, back-end et APIs.',
      color: 'from-yellow-500 to-amber-500',
    },
  ];

  return (
    <section id="services" className="py-20 bg-gradient-to-b from-background to-muted">
      <div className="container">
        <div className="text-center mb-16">
          <span className="inline-block text-sm font-semibold text-primary mb-3 uppercase tracking-wider">Nos Services</span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-display font-bold text-foreground mb-4">
            Des Solutions <span className="text-primary">Sur Mesure</span>
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Open Syne vous accompagne à chaque étape de votre transformation e-commerce
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, index) => {
            const Icon = service.icon;
            return (
              <Card
                key={index}
                className="group hover-lift border-border bg-card overflow-hidden"
              >
                <CardContent className="p-6">
                  <div className="mb-4 relative">
                    <div className="w-14 h-14 rounded-xl bg-secondary flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                      <Icon className="text-primary" size={28} />
                    </div>
                    <div className="absolute -top-2 -right-2 w-20 h-20 bg-primary/5 rounded-full blur-xl group-hover:bg-primary/10 transition-colors"></div>
                  </div>
                  <h3 className="text-xl font-display font-semibold mb-3 text-foreground group-hover:text-primary transition-colors">
                    {service.title}
                  </h3>
                  <p className="text-muted-foreground leading-relaxed">
                    {service.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};